import { Pipe, PipeTransform } from '@angular/core';
import { isAfter, isBefore, parseISO, isEqual, isValid } from 'date-fns';
import { filter } from 'rxjs';

@Pipe({
    name: 'byBordero',
    standalone: false
})
export class byBorderoPipe implements PipeTransform {
  transform(value: any[], ...args: any): any[] {
    args = args[0];
    if (!value || !args || args.length < 3 || !args[0] || !args[1]) {
      return value;
    }

    const startDate = this.parseDate(args[0]);
    const endDate = this.parseDate(args[1]);
    const filterType = args[2];
    console.log('filtertypeus', filterType);

    if (!isValid(startDate) || !isValid(endDate)) {
      return value;
    }

    return value.filter((item) => {
      let itemDate;
      if (filterType === 'order_number' || filterType === 'bo_data') {
        itemDate = this.parseDate(item?.bo_data);
      }

      if (!isValid(itemDate)) {
        return false;
      }

      return (
        (isAfter(itemDate, startDate) || isEqual(itemDate, startDate)) &&
        (isBefore(itemDate, endDate) || isEqual(itemDate, endDate))
      );
    });
  }

  private parseDate(date: string | Date): Date {
    if (date instanceof Date) {
      return date;
    }

    const parsedDate = parseISO(date);
    return isValid(parsedDate) ? parsedDate : new Date(NaN);
  }
}
